export const documentLinkStyles = {
  padding: 0,
  minWidth: 0,
  height: 'auto',
  justifyContent: 'flex-start',
  textAlign: 'left',
};
